import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { floodlightPageLoadEventPropTypes } from '../../prop-types';
import { Layout } from '../../components/layout';
import { OrderHelpPageContent } from '../../components/order-help-page-content';
import { seoPropDefaults, seoPropTypes } from '../../utils/extract-seo-meta-from-entry';

const OrderHelpPage = ({ metaContent, floodlightPageLoadEvent }) => (
  <Layout title="Order Help" {...{ metaContent, floodlightPageLoadEvent }}>
    <OrderHelpPageContent />
  </Layout>
);

OrderHelpPage.propTypes = {
  metaContent: PropTypes.shape(seoPropTypes),
  floodlightPageLoadEvent: floodlightPageLoadEventPropTypes,
};

OrderHelpPage.defaultProps = {
  metaContent: seoPropDefaults,
  floodlightPageLoadEvent: undefined,
};

export default observer(OrderHelpPage);
